import { newDateFromUTC, newDateToUTC } from '@bc-library/common'
import { staffingPeriodFromUTC, staffingPeriodToUTC } from '../project/hooks';
import { internalFundingList } from './index';

// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => {
      return afterReceivingOne(object);
    })
  }
  else if (data.docs && data.count && Array.isArray(data.docs)) {
    data.docs = data.docs.map((object: any) => {
      return afterReceivingOne(object);
    })
  }
  else if (typeof data == 'object') {
    data = afterReceivingOne(data);
  }
  return data;
};


// SINGLE OBJECT
export const afterReceivingOne = (object: any) => {
  if (typeof object == 'object') {
    return {
      ...object,
      staffingPeriod: object.staffingPeriod && staffingPeriodFromUTC(object.staffingPeriod),
      startDate: object.startDate && newDateFromUTC(object.startDate),
      endDate: object.endDate && newDateFromUTC(object.endDate),
      presenceSheetClosedAt: object.presenceSheetClosedAt && new Date(object.presenceSheetClosedAt),
      participants: object.participants && Array.isArray(object.participants) ? object.participants.map(afterReceivingOneParticipant) : object.participants && afterReceivingOneParticipant(object.participants),
      budget: object.budget && object.budget.map((line: any) => {
        return {
          ...line,
          statusPopulated: internalFundingList.find((funding) => funding._id === line.status)
        }
      }),
      meetings: object.meetings && Array.isArray(object.meetings) ? object.meetings.map(afterRceivingOneMeeting) : object.meetings && afterRceivingOneMeeting(object.meetings),
      comments: object.comments?.map((comment: any) => ({
        ...comment,
        _created: comment._created && new Date(comment._created),
        author: typeof comment.authorId === 'object' ? comment.authorId : comment.author,
      })).sort((a: any, b: any) => b._created - a._created),
    }
  }
  return object;
}

const afterRceivingOneMeeting = (meeting: any) => {
  return {
    ...meeting,
    events: meeting.events && Array.isArray(meeting.events) ? meeting.events.map((event: any) => ({
      ...event,
      start: event.start && new Date(event.start),
      end: event.end && new Date(event.end),
    })) : meeting.events && {
      ...meeting.events,
      start: meeting.events.start && new Date(meeting.events.start),
      end: meeting.events.end && new Date(meeting.events.end),
    },
  }
}

const afterReceivingOneParticipant = (participant: any) => {
  return {
    ...participant,
    evaluationCompleted: participant.evaluationCompleted && new Date(participant.evaluationCompleted),
    cancellationDate: participant.cancellationDate && new Date(participant.cancellationDate),
    evaluationReminderSentDates: participant.evaluationReminderSentDates && participant.evaluationReminderSentDates.map((dateStr: string) => new Date(dateStr)),
  }
}

// OBJECT FIELDS

export const beforeSendingComment = (comment:any) => {
  return {
    ...comment,
    date: comment._created && newDateToUTC(comment._created),
  }
}

export const afterReceivingCommentResponse = (commentResponse: any) => {
  return {
    ...commentResponse,
    newComment: {
      ...commentResponse.newComment,
      _created: commentResponse.newComment._created && new Date(commentResponse.newComment._created),
    },
  }
}

// DATA TO BE SENT TO API (TO UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const beforeSending = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => {
      return beforeSendingOne(object);
    })
  }
  else if (typeof data == 'object') {
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object: any) => {
  if (typeof object == 'object') {
    return {
      ...object,
      staffingPeriod: object.staffingPeriod && staffingPeriodToUTC(object.staffingPeriod),
      startDate: object.startDate && newDateToUTC(object.startDate),
      endDate: object.endDate && newDateToUTC(object.endDate),
    }
  }
  return object;
}

// OBJECT FIELDS




